import React, { useEffect, useState } from "react";

function TextField({ response, onChange }) {
  console.log("response editer", response)
  const [value, setValue] = useState(response.value);
  return (
    <div className="form-group">
      <div className="row">
        <input
          className="form-control"
          type="text"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
        />
      </div>
    </div>
  );
}

export default TextField;
